module.exports = __webpack_public_path__ + "img/13.d1dc01c5.jpg";